var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatingAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 120,
    viewBox: "0 0 296 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12675_6743)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M5.23753 42.5126C4.78689 48.5908 5.9605 55.1094 9.07596 61.6185C12.8359 69.4719 17.5693 81.9468 26.3544 88.6416C55.7342 111.029 110.373 120.188 154.475 114.602C155.143 114.52 155.792 114.432 156.446 114.323C156.528 114.321 156.615 114.297 156.696 114.295C163.301 113.357 169.678 111.968 175.763 110.065C185.713 106.959 194.825 102.552 202.611 96.6251C202.935 96.3849 203.241 96.1398 203.546 95.8947C211.02 90.0033 217.244 82.6816 221.714 73.7766C222.05 73.1001 222.361 72.4404 222.672 71.7807C235.085 44.4628 221.607 15.8541 192.657 11.3736C166.175 7.27307 156.8 16.7899 135.132 20.2128C113.47 23.614 88.5327 13.1825 67.6483 7.03041C60.4947 4.91496 52.6558 4.68035 47.4556 4.86953C28.6211 5.59992 7.25129 15.3519 5.23753 42.5126Z",
    fill: "#4182EC"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1193 86.5124C29.0658 89.1472 25.6934 91.9907 22.0054 94.8553C21.8323 92.9024 21.4917 91.2582 20.7608 90.3237C24.604 88.3435 27.0617 86.1929 30.1851 82.9332C29.7462 84.3323 30.7928 85.2456 31.1193 86.5124Z",
    fill: "#FBD682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.106 21.3928C201.916 18.7561 204.892 15.8014 208.196 12.7817C208.39 14.6603 208.706 16.2176 209.406 17.0639C205.976 19.2171 203.797 21.4429 201.042 24.7503C201.382 23.4068 200.421 22.6064 200.106 21.3928Z",
    fill: "#708CD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.479 106.518C124.49 109.535 124.125 114.73 123.937 119.226C125.749 118.33 128.43 117.717 129.688 117.816C128.996 113.711 129.341 109.604 130.18 105.394C129.266 106.455 126.804 106.085 125.479 106.518Z",
    fill: "#708CD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7806 16.0526C28.3184 13.8242 25.8115 10.2697 23.3252 6.38623C25.4377 6.31773 27.2533 6.09439 28.3437 5.37943C29.8473 9.3733 31.7496 11.9515 34.7094 15.2891C33.3331 14.7788 32.1924 15.8074 30.7806 16.0526Z",
    fill: "#EE6F57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6126 47.5338C19.7305 47.5685 15.8237 46.7862 11.6896 45.7582C12.7194 44.5 13.4676 43.2926 13.4956 42.2087C17.1935 43.8546 20.078 44.3649 24.0375 44.7655C22.9756 45.269 23.148 46.5597 22.6126 47.5338Z",
    fill: "#708CD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.035 45.7711C210.655 46.2468 200.189 46.1279 198.627 45.0488C199.461 43.4425 199.768 42.9322 199.628 41.727C203.798 42.7134 208.594 42.3455 212.863 41.3228C212.277 42.6724 211.747 44.0708 212.035 45.7711Z",
    fill: "#FBD682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.456 103.998C150.082 105.788 153.171 107.672 156.62 109.605C157.384 108.22 158.25 107.028 159.363 106.382C155.496 105.102 153.273 103.67 150.596 101.478C150.648 102.397 149.147 103.074 148.456 103.998Z",
    fill: "#EE6F57"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.1668 36.6544C35.2218 31.7707 38.4148 27.0456 43.2984 26.1006L160.26 3.46834C165.144 2.52334 169.869 5.71627 170.814 10.6L183.542 76.3791C184.487 81.2628 181.294 85.9879 176.411 86.9329L59.449 109.565C54.5653 110.51 49.8402 107.317 48.8952 102.434L36.1668 36.6544Z",
    fill: "url(#paint0_linear_12675_6743)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.474 4.57368L43.5123 27.2059C39.2391 28.0328 36.4453 32.1673 37.2722 36.4405L50.0005 102.22C50.8274 106.493 54.9619 109.287 59.2351 108.46L176.197 85.8275C180.47 85.0007 183.264 80.8662 182.437 76.593L169.709 10.8138C168.882 6.54062 164.747 3.7468 160.474 4.57368ZM43.2984 26.1006C38.4148 27.0456 35.2218 31.7707 36.1668 36.6544L48.8952 102.434C49.8402 107.317 54.5653 110.51 59.449 109.565L176.411 86.9329C181.294 85.9879 184.487 81.2628 183.542 76.3791L170.814 10.6C169.869 5.71627 165.144 2.52334 160.26 3.46834L43.2984 26.1006Z",
    fill: "url(#paint1_linear_12675_6743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8427 44.9344L166.26 21.44L176.423 73.9643C177.014 77.0166 175.018 79.9698 171.966 80.5604L61.6023 101.916C58.55 102.507 55.5969 100.511 55.0062 97.4587L44.8427 44.9344Z",
    fill: "url(#paint2_linear_12675_6743)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.494 22.5729L45.9756 45.6999L55.9555 97.275C56.4447 99.803 58.8906 101.456 61.4187 100.967L171.782 79.6112C174.31 79.122 175.963 76.676 175.474 74.148L165.494 22.5729ZM44.8427 44.9344L55.0062 97.4587C55.5969 100.511 58.55 102.507 61.6023 101.916L171.966 80.5604C175.018 79.9698 177.014 77.0166 176.423 73.9643L166.26 21.44L44.8427 44.9344Z",
    fill: "url(#paint3_linear_12675_6743)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.6953,
    cy: 32.7207,
    r: 2.30665,
    transform: "rotate(-10.9515 44.6953 32.7207)",
    fill: "url(#paint4_radial_12675_6743)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.0266,
    cy: 31.3022,
    r: 2.30665,
    transform: "rotate(-10.9515 52.0266 31.3022)",
    fill: "url(#paint5_radial_12675_6743)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.3577,
    cy: 29.8835,
    r: 2.30665,
    transform: "rotate(-10.9515 59.3577 29.8835)",
    fill: "url(#paint6_radial_12675_6743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.279 48.226C108.089 47.2461 108.73 46.298 109.71 46.1084L157.331 36.8937C158.311 36.7041 159.259 37.3447 159.448 38.3247L159.917 40.7448C160.106 41.7248 159.466 42.6729 158.486 42.8625L110.865 52.0772C109.885 52.2668 108.937 51.6261 108.747 50.6462L108.279 48.226Z",
    fill: "url(#paint7_linear_12675_6743)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.514 37.8429L109.894 47.0576C109.438 47.1458 109.14 47.5867 109.228 48.0423L109.697 50.4625C109.785 50.9182 110.226 51.2161 110.681 51.1279L158.302 41.9133C158.758 41.8251 159.056 41.3842 158.967 40.9285L158.499 38.5084C158.411 38.0527 157.97 37.7547 157.514 37.8429ZM109.71 46.1084C108.73 46.298 108.089 47.2461 108.279 48.226L108.747 50.6462C108.937 51.6261 109.885 52.2668 110.865 52.0772L158.486 42.8625C159.466 42.6729 160.106 41.7248 159.917 40.7448L159.448 38.3247C159.259 37.3447 158.311 36.7041 157.331 36.8937L109.71 46.1084Z",
    fill: "url(#paint8_linear_12675_6743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.717 60.8269C110.528 59.8469 111.168 58.8988 112.148 58.7092L148.918 51.5942C149.898 51.4046 150.846 52.0452 151.036 53.0252L151.504 55.4453C151.694 56.4253 151.053 57.3734 150.073 57.563L113.303 64.678C112.323 64.8676 111.375 64.2269 111.186 63.247L110.717 60.8269Z",
    fill: "url(#paint9_linear_12675_6743)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.102 52.5434L112.332 59.6584C111.876 59.7466 111.578 60.1875 111.667 60.6432L112.135 63.0633C112.223 63.519 112.664 63.8169 113.12 63.7288L149.889 56.6138C150.345 56.5256 150.643 56.0847 150.555 55.629L150.087 53.2088C149.998 52.7532 149.557 52.4552 149.102 52.5434ZM112.148 58.7092C111.168 58.8988 110.528 59.8469 110.717 60.8269L111.186 63.247C111.375 64.2269 112.323 64.8676 113.303 64.678L150.073 57.563C151.053 57.3734 151.694 56.4253 151.504 55.4453L151.036 53.0252C150.846 52.0452 149.898 51.4046 148.918 51.5942L112.148 58.7092Z",
    fill: "url(#paint10_linear_12675_6743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.156 73.4277C112.966 72.4478 113.607 71.4997 114.587 71.31L141.755 66.053C142.735 65.8633 143.683 66.504 143.872 67.484L144.341 69.9041C144.53 70.8841 143.89 71.8322 142.91 72.0218L115.742 77.2789C114.762 77.4685 113.814 76.8278 113.624 75.8479L113.156 73.4277Z",
    fill: "url(#paint11_linear_12675_6743)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.938 67.0022L114.77 72.2593C114.315 72.3475 114.017 72.7883 114.105 73.244L114.573 75.6642C114.661 76.1199 115.102 76.4178 115.558 76.3296L142.726 71.0726C143.182 70.9844 143.48 70.5435 143.392 70.0878L142.923 67.6676C142.835 67.2119 142.394 66.914 141.938 67.0022ZM114.587 71.31C113.607 71.4997 112.966 72.4478 113.156 73.4277L113.624 75.8479C113.814 76.8278 114.762 77.4685 115.742 77.2789L142.91 72.0218C143.89 71.8322 144.53 70.8841 144.341 69.9041L143.872 67.484C143.683 66.504 142.735 65.8633 141.755 66.053L114.587 71.31Z",
    fill: "url(#paint12_linear_12675_6743)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.5723,
    y: 52.1605,
    width: 39.9997,
    height: 39.9997,
    rx: 3.50799,
    transform: "rotate(-10.9515 56.5723 52.1605)",
    fill: "url(#paint13_linear_12675_6743)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.5723,
    y: 52.1605,
    width: 39.9997,
    height: 39.9997,
    rx: 3.50799,
    transform: "rotate(-10.9515 56.5723 52.1605)",
    stroke: "url(#paint14_linear_12675_6743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.935 61.1762C72.6402 64.8209 76.1801 67.2129 79.8248 66.5077C83.4695 65.8024 85.8615 62.2625 85.1563 58.6179C84.451 54.9732 80.9111 52.5811 77.2665 53.2864C73.6218 53.9916 71.2297 57.5315 71.935 61.1762ZM94.4197 78.9239L95.8887 78.6396L95.6044 77.1706C94.5075 71.5016 89.0004 67.7803 83.3314 68.8772L77.4553 70.0143C71.7848 71.1115 68.0649 76.6183 69.1619 82.2873L69.4461 83.7563L94.4197 78.9239Z",
    fill: "url(#paint15_radial_12675_6743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.776 70.6291C205.776 84.4139 194.601 95.5887 180.817 95.5887C167.032 95.5887 155.857 84.4139 155.857 70.6291C155.857 56.8443 167.032 45.6695 180.817 45.6695C194.601 45.6695 205.776 56.8443 205.776 70.6291Z",
    fill: "url(#paint16_radial_12675_6743)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.817 94.5545C194.03 94.5545 204.742 83.8427 204.742 70.6291C204.742 57.4155 194.03 46.7037 180.817 46.7037C167.603 46.7037 156.891 57.4155 156.891 70.6291C156.891 83.8427 167.603 94.5545 180.817 94.5545ZM180.817 95.5887C194.601 95.5887 205.776 84.4139 205.776 70.6291C205.776 56.8443 194.601 45.6695 180.817 45.6695C167.032 45.6695 155.857 56.8443 155.857 70.6291C155.857 84.4139 167.032 95.5887 180.817 95.5887Z",
    fill: "url(#paint17_linear_12675_6743)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.882 84.1463L175.887 84.1508L196.582 63.4558L191.583 58.4568L175.881 74.1581L170.049 68.3261L165.05 73.325L175.877 84.1516L175.882 84.1463Z",
    fill: "url(#paint18_linear_12675_6743)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.877 84.1516L175.882 84.1463L175.887 84.1508L196.582 63.4558L191.583 58.4568L175.881 74.1581L170.049 68.3261L165.05 73.325L175.877 84.1516ZM175.877 83.1516L166.05 73.325L170.049 69.326L175.881 75.158L191.583 59.4567L195.582 63.4558L175.887 83.1508L175.882 83.1463L175.877 83.1516Z",
    fill: "url(#paint19_linear_12675_6743)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12675_6743",
    x1: 30.281,
    y1: 40.4407,
    x2: 162.826,
    y2: 76.4761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273E7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#162443"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12675_6743",
    x1: 30.0973,
    y1: 20.8021,
    x2: 168.911,
    y2: 94.8885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C6199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12675_6743",
    x1: 184.717,
    y1: 51.7915,
    x2: 46.1269,
    y2: 34.5887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B5393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B66A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12675_6743",
    x1: 48.2666,
    y1: 48.6282,
    x2: 171.929,
    y2: 80.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6481C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213566"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_12675_6743",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.6953 32.7207) rotate(90) scale(5.89894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833333,
    stopColor: "#B4C8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#506AB8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_12675_6743",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.0266 31.3022) rotate(90) scale(5.89894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833333,
    stopColor: "#B4C8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#506AB8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_12675_6743",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.3577 29.8835) rotate(90) scale(5.89894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833333,
    stopColor: "#B4C8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#506AB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12675_6743",
    x1: 145.834,
    y1: 50.8597,
    x2: 119.254,
    y2: 2.48248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936003,
    stopColor: "#4A65A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12675_6743",
    x1: 133.52,
    y1: 41.501,
    x2: 134.675,
    y2: 47.4698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12675_6743",
    x1: 140.7,
    y1: 64.9258,
    x2: 111.335,
    y2: 19.9872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936003,
    stopColor: "#4A65A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12675_6743",
    x1: 130.533,
    y1: 55.1517,
    x2: 131.688,
    y2: 61.1205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12675_6743",
    x1: 136.438,
    y1: 78.8232,
    x2: 104.177,
    y2: 39.1845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936003,
    stopColor: "#4A65A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12675_6743",
    x1: 128.171,
    y1: 68.6815,
    x2: 129.326,
    y2: 74.6503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12675_6743",
    x1: 102.092,
    y1: 92.7643,
    x2: 55.6303,
    y2: 53.6049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C3DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12675_6743",
    x1: 76.4863,
    y1: 51.7646,
    x2: 76.4863,
    y2: 92.7643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_12675_6743",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.9669 67.2422) rotate(79.0485) scale(36.352 34.4387)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D6AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23356B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_12675_6743",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.892 53.9308) rotate(43.8567) scale(24.1009 57.1746)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38947E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12675_6743",
    x1: 159.956,
    y1: 47.425,
    x2: 183.23,
    y2: 72.8458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#358F7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12675_6743",
    x1: 164.39,
    y1: 68.573,
    x2: 192.023,
    y2: 91.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392754,
    stopColor: "#E5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C78C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_12675_6743",
    x1: 185.953,
    y1: 58.4568,
    x2: 194.103,
    y2: 73.7762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12675_6743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatingAccount);
export default __webpack_public_path__ + "static/media/updating-account.101f759494493d7d07a929d6ce0790d0.svg";
export { ForwardRef as ReactComponent };